import { useState } from "react";
import { ChevronDown, ChevronUp, ArrowRight } from "lucide-react";

import img1 from "../assests/faceimg.webp";
import img2 from "../assests/faceimg.webp";
import img3 from "../assests/faceimg2.webp";
import img4 from "../assests/faceimg.webp";
import img5 from "../assests/faceimg.webp";

const faqData = [
  {
    question: "Is Celiora suitable for sensitive skin?",
    answer:
      "Yes. Our formulas are designed with gentle ingredients inspired by Korean skincare and are suitable for most sensitive skin types.",
    image: img1,
    product: "Barrier Repair Cream",
  },
  {
    question: "How long does it take to see results?",
    answer:
      "Most users notice healthier and more radiant skin within 2–4 weeks with consistent daily use.",
    image: img2,
    product: "Glow Vitamin C Serum",
  },
  {
    question: "Are your products cruelty free?",
    answer:
      "Absolutely. Every Celiora product is cruelty free and carefully formulated without animal testing.",
    image: img3,
    product: "Gentle Foam Cleanser",
  },
  {
    question: "Can I use multiple products together?",
    answer:
      "Yes. Our products are designed to work together as a complete skincare routine for better results.",
    image: img4,
    product: "Hydra Boost Routine",
  },
  {
    question: "Which product is best for dry skin?",
    answer:
      "Our Hydra Moisture Cream deeply hydrates dry skin while strengthening the skin barrier.",
    image: img5,
    product: "Hydra Moisture Cream",
  },
];

const FAQSection = () => {
  const [active, setActive] = useState(0);

  return (
    <section className="faq-section">

      <div className="faq-container">

        <div className="faq-title">

          <span>FREQUENTLY ASKED QUESTIONS</span>

          <h2>
            Everything You Need
            <br />
            To Know
          </h2>

          <p>
            Find answers about Celiora skincare,
            ingredients and product recommendations.
          </p>

        </div>

        <div className="faq-wrapper">

          {/* LEFT */}

          <div className="faq-left">

            {faqData.map((item, index) => (

              <div
                key={index}
                className={`faq-item ${active === index ? "active-faq" : ""}`}
              >

                <button
                  className="faq-question"
                  onClick={() => setActive(index)}
                >

                  <span>{item.question}</span>

                  {active === index ? (
                    <ChevronUp size={20} />
                  ) : (
                    <ChevronDown size={20} />
                  )}

                </button>

                {active === index && (

                  <div className="faq-answer">

                    <p>{item.answer}</p>

                  </div>

                )}

              </div>

            ))}

          </div>

          {/* RIGHT */}

          <div className="faq-right">

            <div className="faq-image-card">

              <img
                src={faqData[active].image}
                alt=""
              />

              <div className="faq-badge">

                Dermatologist
                <br />
                Approved ✔

              </div>

            </div>

            <div className="faq-product">

              <span>Recommended Product</span>

              <h4>
                {faqData[active].product}
              </h4>

              <button>

                Explore Product

                <ArrowRight size={18} />

              </button>

            </div>

          </div>

        </div>

      </div>

    </section>
  );
};

export default FAQSection;